import React from 'react';

import { Form } from '@edx/paragon';
import PropTypes from 'prop-types';

import { SocialAuthProviders } from '../../common-components';
import { LOGIN_PAGE } from '../../data/constants';
import messages from '../messages';

const HintedSSOOnboarding = ({ provider, intl }) => (
  <div className="form-w">
    <div className="d-flex flex-column w-100 h-100 form-login-register-wrapper">
      <div className="d-flex flex-column justify-content-center align-items-center form-login-register-background">
        <Form className="sign-in-form the-new-login-style-campus" id="sign-in-form">
          <div className="the-new-login-style-campus-all-box flex-center-column">
            <h1 className="page-title mb-0 the-new-login-style-campus-h1">
              {intl.formatMessage(messages['login.page.first.step.title'], { enter: <br /> })}
            </h1>
            <h2 className="the-new-login-style-campus-h2">
              {intl.formatMessage(messages['login.page.first.step.subtitle'], { enter: <br /> })}
            </h2>
            <div className="form-w-third-party-auth w-100">
              <div className="social-auth-providers form-w-third-party-auth flex-center-column w-100 the-new-login-button-campus">
                <SocialAuthProviders
                  referrer={LOGIN_PAGE}
                  socialAuthProviders={[provider]}
                  style={{ color: 'white' }}
                />
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  </div>
);

HintedSSOOnboarding.propTypes = {
  provider: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    iconClass: PropTypes.string,
    iconImage: PropTypes.string,
    loginUrl: PropTypes.string,
  }).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default HintedSSOOnboarding;
